var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Repository from './Repository';
import { RequestMethod } from '../Requester';
/**
 * Base class representing a Repository for a model
 */
var ModelRepository = /** @class */ (function (_super) {
    __extends(ModelRepository, _super);
    /**
     * Creates a new repository
     *
     * @param {string} baseUrl - The baseUrl that the repository will use to retrieve the resource
     */
    function ModelRepository(baseUrl) {
        return _super.call(this, baseUrl) || this;
    }
    /**
     * Gets a list of the resource
     *
     * @return {Promise}
     */
    ModelRepository.prototype.all = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request(this.url(), RequestMethod.GET).send()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets a single resource
     *
     * @param id number - The id of the resource
     *
     * @return Promise
     */
    ModelRepository.prototype.find = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.request(this.eUrl(id), RequestMethod.GET).send()];
            });
        });
    };
    /**
     * Gets a list of resources by their ids
     *
     * @param ids number[] - The ids of the resources
     *
     * @return Promise
     */
    ModelRepository.prototype.findAll = function (ids) {
        return __awaiter(this, void 0, void 0, function () {
            var promises, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promises = ids.map(function (id) { return _this.find(id); });
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.sort(function (model1, model2) {
                                return model1.id - model2.id;
                            })];
                }
            });
        });
    };
    /**
     * Creates a new resource or updates an existing one
     *
     * @param model - The model
     *
     * @return {Promise}
     */
    ModelRepository.prototype.save = function (model) {
        if (this.isExistingResource(model)) {
            return this.request(this.eUrl(model), RequestMethod.PUT, model).send();
        }
        return this.request(this.url(), RequestMethod.POST, model).send();
    };
    /**
     * Saves or creates new resources
     *
     * @param models - A list of modals
     *
     * @param {boolean} ordered - Flag to indicate of the objects should be ordered by their id
     */
    ModelRepository.prototype.saveAll = function (models, ordered) {
        if (ordered === void 0) { ordered = false; }
        return __awaiter(this, void 0, void 0, function () {
            var promises, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promises = models.map(function (model) { return _this.save(model); });
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        result = _a.sent();
                        if (ordered) {
                            result = result.sort(function (a, b) {
                                return a.id - b.id;
                            });
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * Destroys a single resource
     *
     * @param model
     *
     * @return {Promise}
     */
    ModelRepository.prototype.destroy = function (model) {
        if (!this.isExistingResource(model)) {
            throw 'Resource cannot be destroyed!';
        }
        return this.request(this.eUrl(model), RequestMethod.DELETE).send();
    };
    /**
     * Destroys a list of resources
     *
     * @param models - The list of resources
     *
     * @return {Promise}
     */
    ModelRepository.prototype.destroyAll = function (models) {
        return __awaiter(this, void 0, void 0, function () {
            var promises;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promises = models.map(function (model) { return _this.destroy(model); });
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates a resource url with an id in it
     *
     * @param {string} url
     *
     * @param model
     *
     * @return {string}
     */
    ModelRepository.prototype.eUrl = function (model, url) {
        var id = this.getModelIdentifier(model);
        return this.url("/".concat(id).concat(url !== null && url !== void 0 ? url : ''));
    };
    /**
     * Checks if the given resource(model) already has been created
     *
     * @param model
     *
     * @return {boolean}
     */
    ModelRepository.prototype.isExistingResource = function (model) {
        return model.id !== undefined;
    };
    /**
     * Returns the identifier of a model
     *
     * @param model
     */
    ModelRepository.prototype.getModelIdentifier = function (model) {
        return (typeof model === 'object') ? model.id : model;
    };
    return ModelRepository;
}(Repository));
export default ModelRepository;
